import { makeStyles } from '@material-ui/core/styles';
import { COLORS, SPACING } from '../constants';

export const useStyles = makeStyles(() => ({
  root: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  stepperBar: {
    background: COLORS.white,
    borderBottom: `1px solid ${COLORS.border}`,
    padding: `12px ${SPACING.sectionGap}px`,
    flexShrink: 0,
  },
  stepperRow: {
    display: 'flex',
    alignItems: 'center',
  },
  stepItem: {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
  },
  stepCircleActive: {
    width: 24,
    height: 24,
    borderRadius: 12,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 11,
    fontWeight: 700,
    color: '#fff',
  },
  stepCircleInactive: {
    width: 24,
    height: 24,
    borderRadius: 12,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 11,
    fontWeight: 700,
    color: COLORS.muted,
  },
  stepConnector: {
    flex: 1,
    height: 2,
    margin: '0 8px',
  },
  scrollContent: {
    flex: 1,
    overflow: 'auto',
    padding: SPACING.sectionGap,
  },
  footer: {
    background: COLORS.white,
    borderTop: `1px solid ${COLORS.border}`,
    padding: `${SPACING.cardPadding}px ${SPACING.sectionGap}px`,
    display: 'flex',
    justifyContent: 'space-between',
    flexShrink: 0,
  },
  footerRight: {
    display: 'flex',
    gap: 12,
  },
  doneContainer: {
    textAlign: 'center',
    padding: `50px ${SPACING.sectionGap}px`,
  },
  doneIcon: {
    width: 56,
    height: 56,
    borderRadius: 28,
    background: COLORS.successLt,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: `0 auto ${SPACING.detailGap}px`,
    fontSize: 24,
  },
  doneActions: {
    display: 'flex',
    gap: 12,
    justifyContent: 'center',
  },
  errorBox: {
    maxWidth: 480,
    margin: `0 auto ${SPACING.formGroupGap}px`,
    padding: SPACING.cardPadding,
    background: COLORS.warnLt,
    border: `1px solid ${COLORS.warn}`,
    borderRadius: 6,
    textAlign: 'left',
  },
  infoBox: {
    maxWidth: 480,
    margin: `0 auto ${SPACING.formGroupGap}px`,
    padding: SPACING.cardPadding,
    background: COLORS.infoLt,
    border: `1px solid ${COLORS.info}`,
    borderRadius: 6,
    textAlign: 'left',
    fontSize: 12,
    color: COLORS.body,
  },
  templateOption: {
    borderRadius: 6,
    padding: `${SPACING.cardPadding}px ${SPACING.cardPaddingHorizontal}px`,
    cursor: 'pointer',
    marginBottom: SPACING.cardMarginBottom,
    display: 'flex',
    alignItems: 'center',
    gap: SPACING.detailGap,
    width: '100%',
    fontFamily: 'inherit',
    textAlign: 'left',
  },
  radioCircle: {
    width: 18,
    height: 18,
    borderRadius: 9,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  radioFill: {
    width: 10,
    height: 10,
    borderRadius: 5,
    background: COLORS.primary,
  },
  createTemplateButton: {
    border: `2px dashed ${COLORS.border}`,
    borderRadius: 6,
    padding: SPACING.cardPadding,
    cursor: 'pointer',
    textAlign: 'center',
    width: '100%',
    background: 'none',
    fontFamily: 'inherit',
  },
  locationStepRoot: {
    display: 'flex',
    gap: SPACING.formGroupGap,
    height: '100%',
    minHeight: 0,
  },
  emptySelectionMessage: {
    padding: 20,
    textAlign: 'center',
    color: COLORS.muted,
    fontSize: 13,
    background: COLORS.white,
    borderRadius: 6,
    border: `1px dashed ${COLORS.border}`,
  },
  selectedChips: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 8,
  },
  selectedChip: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 3,
    padding: '3px 9px',
    background: COLORS.primaryLight,
    borderRadius: 14,
    fontSize: 12,
    color: COLORS.primary,
    fontWeight: 500,
  },
  chipRemoveButton: {
    cursor: 'pointer',
    fontWeight: 700,
    marginLeft: 2,
    background: 'none',
    border: 'none',
    padding: 0,
    font: 'inherit',
    color: 'inherit',
  },
  modeOption: {
    display: 'flex',
    gap: SPACING.detailGap,
    padding: SPACING.cardPadding,
    marginBottom: SPACING.cardMarginBottom,
    borderRadius: 6,
    cursor: 'pointer',
    width: '100%',
    fontFamily: 'inherit',
    textAlign: 'left',
  },
  reviewCard: {
    background: COLORS.white,
    border: `1px solid ${COLORS.border}`,
    borderRadius: 6,
    padding: `${SPACING.cardPadding}px ${SPACING.cardPaddingHorizontal}px`,
    marginBottom: SPACING.detailGap,
  },
  reviewGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    gap: SPACING.formGroupGap,
    marginBottom: SPACING.detailGap,
  },
  reviewLabel: {
    fontSize: 11,
    fontWeight: 700,
    color: COLORS.headerText,
    textTransform: 'uppercase',
    marginBottom: 3,
  },
  reviewBadges: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 8,
    marginBottom: SPACING.formGroupGap,
  },
  reviewSectionLabel: {
    fontSize: 12,
    fontWeight: 600,
    color: COLORS.headerText,
    marginBottom: SPACING.detailGap,
  },
  reviewWarning: {
    padding: SPACING.cardPadding,
    borderRadius: 4,
    fontSize: 12,
  },
}));
